import { motion } from 'framer-motion';

export default function AboutSection() {
  return (
    <section className="relative py-32 bg-dark-medium">
      <div className="container mx-auto px-20">
        <div className="grid grid-cols-2 gap-20 items-center">
          {/* Left Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="w-full h-[600px] rounded-[40px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.4)] border border-neon-purple/30">
              <img 
                src="https://static.readdy.ai/image/5e8897340d9d3c287a609e9913af4db2/f74ce236ea456c4c5e8ad51b741a871a.png" 
                alt="온니잡 플랫폼" 
                className="w-full h-full object-cover object-top"
              />
            </div>
          </motion.div>

          {/* Right Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            {/* Label */}
            <div className="inline-block bg-neon-blue/20 text-neon-blue text-xs font-bold px-5 py-2 rounded-2xl mb-8">
              ABOUT 온니잡
            </div>

            {/* Title */}
            <h2 className="text-6xl font-black text-white leading-tight mb-10">
              나이트라이프 업계를 위한<br />전문 플랫폼
            </h2>

            {/* Description */}
            <p className="text-lg text-slate-400 leading-relaxed mb-14">
              온니잡은 유흥·바·모던바 등 나이트라이프 업종에 특화된 구인구직 플랫폼입니다. 개인회원은 완전 무료로 모든 서비스를 이용할 수 있으며, 기업회원은 검증된 인재 정보에 접근할 수 있습니다.
            </p>

            {/* Button */}
            <button className="w-full h-16 bg-white/10 border border-white/20 rounded-2xl text-white font-semibold text-lg hover:bg-white/15 hover:shadow-neon-purple transition-all flex items-center justify-between px-8 group whitespace-nowrap cursor-pointer">
              <span>플랫폼 자세히 알아보기</span>
              <i className="ri-arrow-right-up-line text-2xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}